import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UserModel } from '../model/user.model';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserService {

	path = '/user';

	constructor(private baseService: BaseService, private authService: AuthService) {
	}

	setApiIp(address: string) {
		this.baseService.apiUrl = address;
	}

	login(user: UserModel) {
		return this.baseService.post(this.path, '/login', user);
	}

  findByPk(id: number) {
    return this.baseService.get(this.path, '/by-id/' + id, { include_signature: true });
  }
	
	getCurrentUserData() {
		return this.baseService.get(this.path, '/token', { token: this.authService.getToken() });
	}

	getByToken(token: string) {
		return this.baseService.get(this.path, '/token', { token });
	}

	getInstitutesDepartamentsByUserId(id: number) {
		return this.baseService.get(this.path, '/' + id + '/institute-departaments');
	}

	getPaginated(init: number, end: number, name: string, email: string, user_type: string, signature_include: boolean = false) {
		return this.baseService.get(this.path, '', { init, end, name, email, user_type, signature_include });
	}

	getAll() {
		return this.baseService.get(this.path, '/all')
	}

	getAllPaginated(query = null) {
		return this.baseService.get(this.path, '', query || { end: 1e+8, init: 0 });
	}

  saveSignatureToken(userId: number, tokenSignature: string): Observable<any> {
    const body = {
      userId: userId,
      tokenSignature: tokenSignature
    };
    return this.baseService.post(this.path, '/save-signature-token', body);
  }

	post(user: UserModel) {
		return this.baseService.post(this.path, '/', user);
	}

	put(color: UserModel) {
		return this.baseService.put(this.path, '/', color);
	}

	delete(idUser: number) {
		return this.baseService.delete(this.path, '/' + idUser);
	}

	restore(idUser: number) {
		return this.baseService.put(this.path, '/restore/' + idUser);
	}

	save(color: UserModel) {
		if (color.id) {
			return this.put(color);
		} else {
			return this.post(color);
		}
	}

	saveInstituteDepartaments(record) {
		return this.baseService.post(this.path, '/' + record.user_id + '/institute-departaments', record.institutes);
	}

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/user.service.ts